import { Utility } from "./utility.js"

export class Title extends Phaser.Scene {
    constructor(level) {
        super({key: "title"})
        this._level = level
        this._startButton = null
    }
    preload() {
        this.load.image("title-background", "assets/title-background.jpg")
        this.load.image("home-check", "assets/home-check.png")
        this.load.image("home-screen-title", "assets/home-screen-title.png")
        this._level.all.forEach(l => this.load.image(`${l.info.key}-logo`, `assets/${l.info.key}/intro-logo.png`))

        this.load.audio({
            key: 'music-home-screen',
            url: [ 'assets/sounds/music-outside.mp3' ]
        });
    }
    create() {
        this.add.image(0, 0, "title-background").setOrigin(0).setDisplaySize(this.sys.canvas.width, this.sys.canvas.height)
        this.add.image(this.cameras.main.centerX, 160, "home-screen-title").setScale(.6).setOrigin(0.5)
        this.updateStartButton("START")
        let logos = this.physics.add.staticGroup()
        for (let i = 0; i < this._level.all.length; i++) {
            const clazz = this._level.all[i]
            let levelPopup = null
            const logo = logos.create(clazz.info.logo.x, clazz.info.logo.y, `${clazz.info.key}-logo`).setScale(.6).setOrigin(0.5).refreshBody()
            logo.setInteractive({ cursor: 'pointer' })
                .on("pointerover", () => { levelPopup = this.levelPopup(logo, clazz.info.name).setVisible(true); logo.setScale(.7)}, this)
                .on("pointerout", () => { levelPopup.setVisible(false); logo.setScale(.6)})
                .on("pointerdown", () => this._level.play.title(i), this)
        }
        if (!this.sound.locked){
            this.playHomeMusic()
        } else{
            this.sound.once(Phaser.Sound.Events.UNLOCKED, () => {
                this.playHomeMusic()
            })
        }
    }
    updateStartButton(start) {
        this._startButton && this._startButton.destroy()
        this._startButton = Utility.make.button(start, {scene: this, x: this.cameras.main.centerX, y: this.cameras.main.centerY})
        this._startButton.on("pointerdown", () => this._level.play.latest())
    }
    levelPopup(i, name){
        let board = this.add.container(i.x - 100, 380).setSize(200,60)
        let rect = this.add.graphics().fillStyle(0x070b34, 1).fillRoundedRect(0, 0, 220, 60, 10)
        let point1X = Math.floor(220 / 2.5)
        let point1Y = 60
        let point2X = Math.floor((220 / 3.3) * 1.7)
        let point2Y = 60
        let point3X = Math.floor(220 / 2.2)
        let point3Y = Math.floor(60 + 10)
        rect.fillTriangle(point1X, point1Y, point2X, point2Y, point3X, point3Y)
        board.add(rect)
        board.add(Utility.make.text(this, board.width / 2 + 10, board.height / 2, name, {
            fontSize: "16px", fill: "#ffffff", align: "center", wordWrap: { width: 200, useAdvancedWrap: true }}
        ).setOrigin(.5).setResolution(2))
        return board
    }
    playHomeMusic(){
        this.sound.add("music-home-screen", { mute: false, volume: 0.2, rate: 1, detune: 0, seek: 0, loop: true, delay: 0 }).play()
    }
}